import React from 'react';
import { Dropdown, Space, Tag } from 'antd';
import { SkinOutlined, CheckOutlined } from '@ant-design/icons';
import { THEME_PRESETS, ThemeKey } from '../theme/themes';
import { useAppTheme } from '../theme/ThemeProvider';
import { useTranslation } from 'react-i18next';

const ThemeSwitcher: React.FC = () => {
  const { themeKey, setThemeKey } = useAppTheme();
  const { t } = useTranslation();

  const items = (Object.keys(THEME_PRESETS) as ThemeKey[]).map(key => {
    const preset = THEME_PRESETS[key];
    return {
      key,
      label: (
        <Space align="center" size={8}>
          <span
            style={{
              display: 'inline-block',
              width: 12,
              height: 12,
              borderRadius: 2,
              background: preset.previewColor,
              border: '1px solid rgba(0,0,0,0.08)',
            }}
          />
          <span>{preset.name}</span>
          {themeKey === key ? (
            <Tag color="success" style={{ marginLeft: 8 }}>
              <CheckOutlined />
            </Tag>
          ) : null}
        </Space>
      ),
      onClick: () => setThemeKey(key),
    };
  });

  return (
    <Dropdown
      menu={{ items }}
      placement="bottomRight"
      trigger={['hover', 'click']}
      mouseEnterDelay={0.1}
    >
      <Space style={{ cursor: 'pointer' }} size="small">
        <SkinOutlined />
        <span>{t('common.theme')}</span>
      </Space>
    </Dropdown>
  );
};

export default ThemeSwitcher;
